// extracted by mini-css-extract-plugin
module.exports = {"container":"RecipeNameAndTags_container__Qkl2O","tags":"RecipeNameAndTags_tags__3LDpu","catalogItemName":"RecipeNameAndTags_catalogItemName__026CG"};